import { clearGuestSession } from "@/lib/guest-session";
import { CART_STORAGE_KEY } from "@/lib/cart-local-storage";
import { getStoredTable, persistTableContext } from "@/atoms/table";

/** User storage cleared on logout, preserving the merchant host. */
export const USER_STORAGE_KEYS = [
  'meucontroleai:account-token',
  'meucontroleai:account-token-expires',
  'profile',
  CART_STORAGE_KEY,
  'meucontroleai:holiday-hours',
] as const;

/** Clears guest/user state while preserving the current table context. */
export function clearUserStorage() {
  clearGuestSession();
  USER_STORAGE_KEYS.forEach(key => {
    localStorage.removeItem(key);
  });

  const table = getStoredTable();
  sessionStorage.clear();
  if (table) persistTableContext(table);
}
